import { FC, ReactNode } from 'react';

import classNames from 'classnames';

import styles from './DesktopSidebar.module.scss';

interface IDesktopSidebarProps {
	children: ReactNode;
}

export const DesktopSidebar: FC<IDesktopSidebarProps> = ({ children }) => {
	return <section className={classNames(styles['sidebar'], 'sidebar')}>{children}</section>;
};
